<template>
  <div>
    <v-row align="center" style="margin: 20px">
      <v-col class="d-flex" cols="12" sm="12" lg="4">
        <span>جنسیت</span>
        <v-select
          :items="jensiatItems"
          item-text="text"
          item-value="value"
          v-model="jens"
          @input="callWithCitySelect"
        ></v-select>
      </v-col>
      <v-col class="d-flex" cols="12" sm="12" lg="4">
        <span>استان</span>
        <v-select
          :items="ostans"
          item-text="text"
          item-value="value"
          v-model="ostan"
          @input="callWithCitySelect"
        ></v-select>
      </v-col>
      <v-col class="d-flex" cols="12" sm="12" lg="4">
        <span>شهرستان</span>
        <v-select
          :items="cities"
          item-text="text"
          item-value="value"
          v-model="city"
          @input="callWithCitySelect"
        ></v-select>
      </v-col>
    </v-row>
    <div v-if="isMobile">
      <app-schools
        v-for="item in schools"
        :key="item.schoolSerial"
        :school="item"
        @clicked="goToRoute(`${detailRoute}${item.schoolSerial}`)"
      >
      </app-schools>
    </div>
    <div v-else>
      <div>
        <v-data-table
          :items="schools"
          :headers="schoolHeaders"
          item-key="schoolSerial"
          class="elevation-1 rounded"
          single-expand
          :no-data-text="tableText"
          :item-class="rowClass"
          :footer-props="{
            itemsPerPageAllText: 'همه',
            itemsPerPageText: 'تعداد ردیف',
          }"
          ><template v-slot:[`item.sath`]="{ item }">
            {{
              `سطوح  ${item.isSath1 === "True" ? " 1" : ""}` +
                `${item.isSath2 === "True" ? " 2" : ""}` +
                `${item.isSath3 === "True" ? " 3" : ""}`
            }}
          </template>
          <template v-slot:[`item.jensiat`]="{ item }">
            {{ item.jensiatSerial == 2 ? "خواهران" : "برادران" }}
          </template>
          <template v-slot:[`item.introduction`]="{ item }">
            <div class="text">{{ item.introduction }}</div>
          </template>
          <template v-slot:[`item.details`]="{ item }">
            <v-btn
              class="grid"
              color="green white--text"
              rounded
              @click="goToRoute(`${detailRoute}${item.schoolSerial}`)"
            >
              {{ "جزییات" }}
            </v-btn>
          </template>
          <template v-slot:[`footer.page-text`]="{ pageStart, pageStop }">
            از {{ pageStart }} تا {{ pageStop }}
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>
<script>
import { getAllOstanCity, getAllSchools } from "@/api/aboutus";
import schoolsApp from "./SchoolsApp";

export default {
  components: {
    appSchools: schoolsApp,
  },
  data() {
    return {
      detailRoute: "/aboutus/schools/",
      jensiatItems: [
        { value: "-1", text: "همه موارد" },
        { value: "1", text: "برادران" },
        { value: "2", text: "خواهران" },
      ],
      jens: "-1",
      schoolHeaders: [
        {
          text: "نام مدرسه",
          value: "schoolName",
          width: "20%",
        },
        {
          text: "معرفی",
          value: "introduction",
          width: "40%",
        },
        {
          text: "جنسیت",
          value: "jensiat",
          width: "10%",
        },
        {
          text: "مجوزتدریس",
          value: "sath",
          width: "10%",
        },
        {
          text: "تعداد طلاب",
          value: "studentCount",
          width: "10%",
        },
        {
          text: "جزییات",
          value: "details",
          width: "10%",
          sortable: false,
        },
      ],
      showModal: false,
      scrollY: 0,
      selectedIndex: -1,
      showDetails: false,
      ayins: [],
      //خراسان رضوی
      ostan: "1055",
      //مشهد
      city: "81",
      schools: [],
    };
  },
  computed: {
    ostanCities() {
      return this.$store.getters.ostanCities;
    },
    callWithCitySelect() {
      this.$store.commit("SET_TABLE_TEXT", true);
      let cityValue = "";
      let jensValue = "";
      if (this.city === "-1") cityValue = "";
      else cityValue = this.city;
      if (this.jens === "-1") jensValue = "";
      else jensValue = this.jens;
      this.$store.commit("SET_TABLE_TEXT", true);
      this.$store.commit("SET_PROGRESS_SHOW", true);
      getAllSchools(cityValue, jensValue)
        .then((response) => {
          const data = response.data;
          this.$store.commit("SET_TABLE_TEXT", false);
          if (data) {
            this.schools = data;
          }
          this.$store.commit("SET_TABLE_TEXT", false);
          this.$store.commit("SET_PROGRESS_SHOW", false);
        })
        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
    ostans() {
      let ostans = [];
      //همه موارد
      ostans.push({ value: "-1", text: "همه موارد" });
      this.ostanCities.map((item) => {
        if (!ostans.some((el) => el.value === item.srl_Ostan))
          ostans.push({ value: item.srl_Ostan, text: item.name_Ostan });
      });
      return ostans;
    },
    cities() {
      let cities = [];
      //همه موارد
      cities.push({ value: "-1", text: "همه موارد" });
      this.ostanCities.map((item) => {
        if (item.srl_Ostan === this.ostan)
          cities.push({
            value: item.srl_City,
            text: item.name_City,
          });
      });
      return cities;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
  },
  created() {
    this.$store.dispatch("getAllOstanCity");
  },
  methods: {
    goToRoute(route) {
      window.scrollTo(0, 0);
      if (route.search("/") == 0) {
        this.$router.push(route);
      } else {
        window.open(route);
      }
    },
    hideModal() {
      this.showModal = false;
    },
    getAllOstanCities() {
      getAllOstanCity()
        .then((response) => {
          const data = response.data;
          if (data) {
            this.ostanCities = data;
            this.callWithCitySelect();
          }
        })
        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
    getAllSchools(citySerial, jensitaSerial) {
      getAllSchools({ citySerial, jensitaSerial })
        .then((response) => {
          const data = response.data;
          if (data) {
            this.schools = data;
          }
        })
        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
    rowClass(item) {
      let rowClass = item.description === "" ? "no-expand" : "";
      return rowClass;
    },
  },
};
</script>
<style>
.directionLTR {
  direction: ltr;
}
.text {
  height: 18px;
  width: 500px;
  padding: 0;
  overflow: hidden;
  position: relative;
  display: inline-block;
  margin: 0 5px 0 5px;
  text-align: center;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #000;
}
</style>
